import {
  AddDeleteNodeData,
  AppsStateOrganization,
  ChangeNodeData,
  EMPTY_LOCATION,
  EMPTY_NODE,
  HistoryActionType,
  HistoryEvent,
  INodesMap,
  NodeType,
  OrganizationNode,
  OrganizationNodeDTO,
} from ".";
import { fromTreeTopToCondition } from "./selectors";
import {
  IAddNodeBranchSuccess,
  IGetAllNodesInfoSuccess,
  IGetOrganizationHistorySuccess,
  IOrganizationGetInfoSuccess,
  IOrganizationPageActive,
  ISetOrganizationIdFromToken,
  ISetSettingsOrganization,
  IUpdateCountOfDevicesBySocket,
  IUpdateCountOfResidentsBySocket,
  IUpdateOrganizationBySocket,
  IUpdateOrganizationImageBySocket,
  IUpdateOrganizationNodeBySocket,
  IUpdateOrganizationNodeImageBySocket,
  ORGANIZATION,
  OrganizationActionType,
} from "./types";

const initialState: AppsStateOrganization = {
  rootOrganization: {
    id: undefined,
    nodesTree: [],
    title: undefined,
    type: undefined,
    location: {
      zipCode: undefined,
      avatarUrl: undefined,
      city: undefined,
      coordinates: {
        latitude: 0,
        longitude: 0,
      },
      countryCode: undefined,
      timezone: undefined,
      addressLine2: undefined,
      addressLine1: undefined,
    },
  },
  settings: {
    searchValue: "",
    narrowType: undefined,
    zoom: 1,
  },
  nodes: [],
  isLoading: undefined,
  isLoadingNodesInfo: undefined,
  isPageActive: false,
  nodesMap: {},
  history: [],
  organizationId: undefined,
  isCreatingOrganization: undefined,
};

const reducer = (
  state = initialState,
  action: OrganizationActionType
): AppsStateOrganization => {
  switch (action.type) {
    case ORGANIZATION.GET_ORGANIZATION_REQUEST: {
      const { blocking } = action.payload;
      return blocking ? { ...state, isLoading: true } : state;
    }
    case ORGANIZATION.ADD_NODE_REQUEST:
    case ORGANIZATION.EDIT_NODE_REQUEST:
    case ORGANIZATION.DELETE_NODE_REQUEST:
    case ORGANIZATION.ADD_NODE_BRANCH_REQUEST: {
      return state;
      // {
      //     ...state,
      //     isLoading: true,
      // };
    }
    case ORGANIZATION.GET_ORGANIZATION_FAILURE: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case ORGANIZATION.ADD_NODE_FAILURE:
    case ORGANIZATION.ADD_NODE_SUCCESS:
    case ORGANIZATION.GET_DETAILS_FAILURE:
    case ORGANIZATION.EDIT_NODE_FAILURE:
    case ORGANIZATION.DELETE_NODE_FAILURE:
    case ORGANIZATION.EDIT_NODE_SUCCESS:
    case ORGANIZATION.DELETE_NODE_SUCCESS:
    case ORGANIZATION.ADD_NODE_BRANCH_FAILURE: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case ORGANIZATION.ADD_NODE_BRANCH_SUCCESS: {
      const { id, data } = (action as IAddNodeBranchSuccess).payload;
      if (data !== null) {
        const nodesMap: INodesMap = {
          ...state.nodesMap,
          [id]: {
            ...EMPTY_NODE,
            countOfDevices: 0,
            countOfResidents: 0,
            nodesTree: [],
            location: data.location,
          },
        };
        return { ...state, nodesMap };
      }
      return state;
    }
    case ORGANIZATION.GET_ALL_NODES_INFO_REQUEST: {
      return { ...state, isLoadingNodesInfo: true };
    }
    case ORGANIZATION.GET_ALL_NODES_INFO_FAILURE: {
      return { ...state, isLoadingNodesInfo: false };
    }
    case ORGANIZATION.GET_ALL_NODES_INFO_SUCCESS: {
      const data = (action as IGetAllNodesInfoSuccess).payload;
      const newNodesMap = { ...state.nodesMap };
      const mapping = (el: OrganizationNodeDTO): OrganizationNode => {
        const wasNode = { ...findNodeById(el.self.id, state.nodes) };
        const newNode = {
          ...wasNode,
          title: el.title,
          location: el.location,
          countOfDevices: el.countOfDevices,
          countOfResidents: el.countOfResidents,
          nodesTree: el.nodesTree.map((child) => mapping(child)),
        };
        newNodesMap[newNode.id] = newNode;
        return newNode;
      };
      if (data.type.toLowerCase() !== "root") {
        mapping(data);
      } else
        data.nodesTree.map((el) => {
          return mapping(el);
        });

      return {
        ...state,
        nodesMap: newNodesMap, //new Map(state.nodesMap.set(resMap[0].id, resMap[0])),
        isLoading: false,
        isLoadingNodesInfo: false,
      };
    }
    case ORGANIZATION.GET_ORGANIZATION_SUCCESS: {
      const response = (action as IOrganizationGetInfoSuccess).payload;
      const { nodesTree, ...rest } = response;
      const mapping = (el: OrganizationNodeDTO): OrganizationNode => {
        const wasNode = { ...findNodeById(el.self.id, state.nodes) };
        return {
          id: el.self.id,
          title: el.title,
          location: wasNode.location,
          nodesTree: el.nodesTree.map((child) => mapping(child)),
          type: el.type,
        };
      };
      const resMap: OrganizationNode[] = nodesTree.map((el) => {
        return mapping(el);
      });
      resMap[0] = { ...resMap[0], title: rest.title, location: rest.location };
      const newNodesMap = {
        ...state.nodesMap,
        [resMap[0].id]: { ...resMap[0], ...rest },
      };
      // console.log('organization success');
      return {
        ...state,
        rootOrganization: { ...state.rootOrganization, ...rest },
        nodesMap: newNodesMap, //new Map(state.nodesMap.set(resMap[0].id, resMap[0])),
        nodes: resMap,
        isLoading: false,
        organizationId: response["id"] ? response["id"] : state.organizationId,
      };
    }

    case ORGANIZATION.UPDATE_ORGANIZATION_NODE_BY_SOKET: {
      const data = (action as IUpdateOrganizationNodeBySocket).payload;
      const node = findNodeById(data.nodeId, state.nodes);
      const nodeFromRoot = findNodeById(
        data.nodeId,
        state.rootOrganization.nodesTree
      );
      let newNodesMap = { ...state.nodesMap };
      if (node) {
        node.leaf = data.leaf;
        node.location = data.location;
        node.title = data.title;
        node.type = data.type;
        newNodesMap = {
          ...state.nodesMap,
          [node.id]: { ...newNodesMap[node.id], title: data.title },
        };
      }
      if (nodeFromRoot) {
        node.leaf = data.leaf;
        node.location = data.location;
        node.title = data.title;
        node.type = data.type;
      }

      return {
        ...state,
        rootOrganization: { ...state.rootOrganization },
        nodes: [...state.nodes],
        nodesMap: newNodesMap,
      };
    }
    case ORGANIZATION.UPDATE_NODE_IMAGE: {
      const data = (action as IUpdateOrganizationNodeImageBySocket).payload;
      const node = findNodeById(data.nodeId, state.nodes);
      let newNodesMap = { ...state.nodesMap };
      const newAvatar = data.url !== null ? data.url : "";
      if (node) {
        if (node.location) node.location.avatarUrl = newAvatar;
        else {
          const stub = state.nodesMap[data.nodeId];
          if (stub.location)
            node.location = { ...stub.location, avatarUrl: newAvatar };
          else node.location = { ...EMPTY_LOCATION, avatarUrl: newAvatar };
        }
        newNodesMap = { ...state.nodesMap, [node.id]: { ...node } };
      }

      return {
        ...state,
        nodes: [...state.nodes],
        nodesMap: newNodesMap,
      };
    }
    case ORGANIZATION.UPDATE_ORGANIZATION_IMAGE: {
      const data = (action as IUpdateOrganizationImageBySocket).payload;
      const newAvatar =
        data.url !== null && data.url !== undefined ? data.url : "";
      const newRoot = {
        ...state.nodes[0],
        location: { ...state.nodes[0].location, avatarUrl: newAvatar },
      };

      const newRootOrg = {
        ...state.rootOrganization,
        location: { ...state.rootOrganization.location, avatarUrl: newAvatar },
      };
      const newNodesMap = { ...state.nodesMap, [newRoot.id]: newRoot };
      // if (node) {
      //     node.location.avatarUrl = data.url;
      //     newNodesMap = { ...state.nodesMap, [node.id]: { ...node } };
      // }

      return {
        ...state,
        rootOrganization: newRootOrg,
        nodes: [newRoot],
        nodesMap: newNodesMap,
      };
    }
    case ORGANIZATION.UPDATE_ORGANIZATION_BY_SOKET: {
      const data = (action as IUpdateOrganizationBySocket).payload;
      const node = state.nodesMap[data.nodeId];
      if (!node && data.nodeId === data.orgId) {
        const newRoot = {
          ...state.nodes[0],
          location: data.location,
          title: data.title,
        };
        const newRootOrg = {
          ...state.rootOrganization,
          location: data.location,
        };
        const newNodesMap = { ...state.nodesMap, [newRoot.id]: newRoot };
        if (data.title !== undefined)
          return {
            ...state,
            rootOrganization: { ...newRootOrg, title: data.title },
            nodes: [{ ...newRoot, title: data.title }],
            nodesMap: newNodesMap,
          };
        return {
          ...state,
          rootOrganization: newRootOrg,
          nodes: [newRoot],
          nodesMap: newNodesMap,
        };
      }
      const nodeFromRoot = findNodeById(
        data.nodeId,
        state.rootOrganization.nodesTree
      );
      const nodeFromNodes = findNodeById(data.nodeId, state.nodes);
      let newNodesMap = { ...state.nodesMap };
      if (node) {
        node.location = data.location;
        node.title = data.title;
        newNodesMap = { ...state.nodesMap, [node.id]: { ...node } };
      }
      if (nodeFromRoot) {
        node["location"] = data.location;
        node["title"] = data.title;
      }
      if (nodeFromNodes) {
        node.location = data.location;
        node.title = data.title;
      }
      return {
        ...state,
        rootOrganization: { ...state.rootOrganization },
        nodes: [...state.nodes],
        nodesMap: newNodesMap,
      };
    }

    case ORGANIZATION.UPDATE_COUNT_OF_RESIDENTS_BY_SOKET: {
      const data = (action as IUpdateCountOfResidentsBySocket).payload;
      const node = state.nodesMap[data.nodeId];
      if (!node || !node.countOfResidents) return state;
      console.log(node?.title + data.increase);
      const newVal = (oldVal: number): number => {
        return data.increase ? oldVal + 1 : oldVal - 1;
      };
      if (node) {
        const parents = fromTreeTopToCondition(
          state.nodes[0],
          (el) => el.id === data.nodeId
        )
          .filter((el) => el.type !== NodeType.Root && el.id !== data.nodeId)
          .reverse(); //max 4, - root, -myself
        let newNodesMap = {
          ...state.nodesMap,
          [data.nodeId]: {
            ...node,
            countOfResidents: newVal(node.countOfResidents),
          },
        };
        if (parents.length > 0) {
          //departmentLevel in a worst scenario
          const dep = { ...state.nodesMap[parents[0].id] };
          dep.nodesTree.splice(
            dep.nodesTree.findIndex((el) => el.id === node.id),
            1,
            {
              ...node,
              countOfResidents: newVal(node.countOfResidents),
            }
          );
          newNodesMap = {
            ...newNodesMap,
            [dep.id]: {
              ...dep,
            },
          };
          if (parents.length > 1) {
            //building level in a worst scenario
            const build = { ...state.nodesMap[parents[1].id] };
            build.nodesTree.splice(
              build.nodesTree.findIndex((el) => el.id === dep.id),
              1,
              {
                ...dep,
              }
            );
            newNodesMap = {
              ...newNodesMap,
              [build.id]: {
                ...build,
              },
            };
          }
        }
        return {
          ...state,
          nodesMap: newNodesMap,
        };
      }
      return state;
    }
    case ORGANIZATION.UPDATE_COUNT_OF_DEVICES_BY_SOKET: {
      const data = (action as IUpdateCountOfDevicesBySocket).payload;
      const node = state.nodesMap[data.nodeId];
      if (!node || !node.countOfDevices) return state;
      console.log(node.title + data.increase);
      const newVal = (oldVal: number): number => {
        return data.increase ? oldVal + 1 : oldVal - 1;
      };
      if (node) {
        const parents = fromTreeTopToCondition(
          state.nodes[0],
          (el) => el.id === data.nodeId
        )
          .filter((el) => el.type !== NodeType.Root && el.id !== data.nodeId)
          .reverse(); //max 4, - root, -myself
        let newNodesMap = {
          ...state.nodesMap,
          [data.nodeId]: {
            ...node,
            countOfDevices: newVal(node.countOfDevices),
          },
        };
        if (parents.length > 0) {
          //departmentLevel in a worst scenario
          const dep = { ...state.nodesMap[parents[0].id] };
          dep.nodesTree.splice(
            dep.nodesTree.findIndex((el) => el.id === node.id),
            1,
            {
              ...node,
              countOfDevices: newVal(node.countOfDevices),
            }
          );
          newNodesMap = {
            ...newNodesMap,
            [dep.id]: {
              ...dep,
            },
          };
          if (parents.length > 1) {
            //building level in a worst scenario
            const build = { ...state.nodesMap[parents[1].id] };
            build.nodesTree.splice(
              build.nodesTree.findIndex((el) => el.id === dep.id),
              1,
              {
                ...dep,
              }
            );
            newNodesMap = {
              ...newNodesMap,
              [build.id]: {
                ...build,
              },
            };
          }
        }
        return {
          ...state,
          nodesMap: newNodesMap,
        };
      }
      return state;
    }
    case ORGANIZATION.HISTORY_SUCCESS: {
      const data = (action as IGetOrganizationHistorySuccess).payload;
      const dataReal: HistoryEvent[] = [];
      data.forEach((el: any) => {
        const { old_data, new_data, ...rest } = el;

        let histEvt = rest;
        if (
          el.action === HistoryActionType.created ||
          el.action === HistoryActionType.deleted
        ) {
          const payload =
            el.action === HistoryActionType.created
              ? new_data.payload
              : old_data.payload;
          const parentNode: OrganizationNode = findNodeById(
            payload.parentNodeId,
            state.nodes
          );
          const newData: AddDeleteNodeData = {
            title: payload.title,
            type: payload?.type,
            parentNodeType: parentNode?.type,
            parentTitle: parentNode?.title,
          };
          histEvt = { ...histEvt, data: newData };
          dataReal.push(histEvt);
        } else if (el.action === HistoryActionType.changed) {
          if (Object.keys(old_data).length !== 0) {
            const thisNode: OrganizationNode = findNodeById(
              Number.parseInt(el?.resource_id),
              state.nodes
            );
            if (thisNode) {
              if (
                thisNode.type === NodeType.Group ||
                thisNode.type === NodeType.Department
              ) {
                /// only thing that can be changed is title
                const oldPayloadTitle = old_data["payload.title"];
                const newPayloadTitle = new_data["payload.title"];
                const newData: ChangeNodeData = {
                  title: newPayloadTitle,
                  type: thisNode?.type,
                  oldTitle: oldPayloadTitle,
                };
                histEvt = { ...histEvt, data: newData };
              } else {
                //thats building it's bad
                const sameKeys: string[] = [];
                Object.keys(old_data).forEach((key: string) => {
                  if (
                    new_data[key] !== undefined &&
                    key.indexOf("nodesTree") === -1
                  )
                    // no child data display
                    sameKeys.push(key);
                });
                const newData: ChangeNodeData = {
                  type: thisNode?.type,
                  title: thisNode.title,
                };
                sameKeys.forEach((key: string) => {
                  if (key === "payload.title") {
                    newData.title = new_data[key];
                    newData.oldTitle = old_data[key];
                  } else if (key.indexOf("addressLine1") !== -1) {
                    newData.addressLine1 = new_data[key];
                    newData.oldaddressLine1 = old_data[key];
                  } else if (key.indexOf("addressLine2") !== -1) {
                    newData.addressLine2 = new_data[key];
                    newData.oldaddressLine2 = old_data[key];
                  } else if (key.indexOf("countryCode") !== -1) {
                    newData.countryCode = new_data[key];
                    newData.oldcountryCode = old_data[key];
                  } else if (key.indexOf("city") !== -1) {
                    newData.city = new_data[key];
                    newData.oldcity = old_data[key];
                  } else if (key.indexOf("zipCode") !== -1) {
                    newData.zipCode = new_data[key];
                    newData.oldzipCode = old_data[key];
                  } else if (key.indexOf("avatarUrl") !== -1) {
                    newData.avatarUrl = new_data[key];
                    newData.oldavatarUrl = old_data[key];
                  } else if (key.indexOf("stateProvinceRegion") !== -1) {
                    newData.stateProvinceRegion = new_data[key];
                    newData.oldstateProvinceRegion = old_data[key];
                  }
                });
                histEvt = { ...histEvt, data: newData };
                console.log(sameKeys);
              }
              dataReal.push(histEvt);
            }
          }
        }
      });
      // data.forEach((el) => {
      //     const { old_data, new_data, ...rest } = el;
      //     const histEvt = { rest };
      //     if (Object.keys(new_data).length !== 0) {
      //         if (el.action == HistoryActionType.changed) {

      //         }
      //         else if (el.action === HistoryActionType.created) {

      //         }
      //         dataReal.push(histEvt);
      //     }

      // });
      return { ...state, history: dataReal };
    }
    case ORGANIZATION.SET_SETTINGS: {
      const newSettings = (action as ISetSettingsOrganization).payload;
      return { ...state, settings: { ...state.settings, ...newSettings } };
    }
    case ORGANIZATION.PAGE_ACTIVE: {
      const data = (action as IOrganizationPageActive).payload;
      return { ...state, isPageActive: data };
    }
    case ORGANIZATION.SET_ORGANIZATION_ID_FROM_TOKEN: {
      const data = (action as ISetOrganizationIdFromToken).payload;
      if (data !== state.organizationId)
        return { ...state, organizationId: data };
      return state;
    }
    case ORGANIZATION.CREATE_ORGANIZATION: {
      return { ...state, isCreatingOrganization: true };
    }
    case ORGANIZATION.CREATE_ORGANIZATION_FAILURE:
    case ORGANIZATION.CREATE_ORGANIZATION_SUCCESS: {
      return { ...state, isCreatingOrganization: false };
    }

    default:
      return state;
  }
};

const findNodeById = (
  nodeId: number,
  nodes: OrganizationNode[]
): OrganizationNode => {
  const finder = (node: OrganizationNode): OrganizationNode => {
    if (node === undefined) return EMPTY_NODE(nodeId);
    if (node.id === nodeId) {
      return node;
    } else if (node.nodesTree != null) {
      let result = null;
      for (let i = 0; result == null && i < node.nodesTree.length; i++) {
        result = finder(node.nodesTree[i]);
      }
      return result;
    }
    return null;
  };
  return finder(nodes[0]);
};
export default reducer;
